import React, { useEffect, useState, useRef } from "react";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import ResultSearchBox from "../components/Search/ResultSearchBox";
import SearchResultBox from "../components/SearchResult/SearchResultBox";
import SearchResultOptions from "../components/SearchResult/SearchResultOptions";
import { connect } from "react-redux";
import { 
  addPath, 
  saveSearchWord, 
  setSearchId,
  saveSearchResult,
  saveSearchResultAuthDocs,
  setEquipment,
  setTypes,
  setTotalDoc,
  addfilter,
  setActivePage,
  saveSpellcorrection,
  setToaster,
  setSearchLoading
} from "../redux/actions";
import { Loader } from "semantic-ui-react";
import { v4 as uuidv4 } from "uuid";
import {
  storeOutline,
  storeFileLink,
  storeDocDetail,
} from "../redux/actions";

import QAengine from "../components/QAengineBox/QAengine";
import { useLocation } from "react-router";
import { getSasUrl, getSarasAnswer, getSarasAnswerStream, searchApi } from "../components/apiCall"; // Import all needed APIs
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import KeycloakUserService from "../keycloak/KeycloakUserService.js";

// In-memory storage for answer persistence (replace with localStorage in your environment)
const answerStorage = {
  data: null,

  set: (key, value) => {
    // Use this instead: localStorage.setItem(key, JSON.stringify(value));
    answerStorage.data = { [key]: value };
  },

  get: (key) => {
    // Use this instead: return JSON.parse(localStorage.getItem(key) || 'null');
    return answerStorage.data?.[key] || null;
  },

  remove: (key) => {
    // Use this instead: localStorage.removeItem(key);
    if (answerStorage.data && answerStorage.data[key]) {
      delete answerStorage.data[key];
    }
  }
};

// Skeleton loading component for Saras answer
const AnswerSkeleton = () => {
  return (
    <div className="bg-[#fafafa] shadow-md rounded-md p-6 max-w-[83rem] mx-auto mt-6">
      <div className="space-y-4">
        <div className="h-4 skeleton-line rounded w-3/4"></div>
        <div className="h-4 skeleton-line rounded w-full"></div>
        <div className="h-4 skeleton-line rounded w-5/6"></div>
        <div className="space-y-2">
          <div className="h-4 skeleton-line rounded w-full"></div>
          <div className="h-4 skeleton-line rounded w-4/5"></div>
          <div className="h-4 skeleton-line rounded w-full"></div>
        </div>
        <div className="h-4 skeleton-line rounded w-2/3"></div>
        <div className="space-y-2">
          <div className="h-4 skeleton-line rounded w-full"></div>
          <div className="h-4 skeleton-line rounded w-3/4"></div>
        </div>
        <div className="flex space-x-4 mt-6">
          <div className="h-8 skeleton-line rounded-full w-32"></div>
          <div className="h-8 skeleton-line rounded-full w-28"></div>
          <div className="h-8 skeleton-line rounded-full w-36"></div>
        </div>
      </div>
    </div>
  );
};

const AnswerBox = ({ html, getSasUrl, citations, onFollowUpClick, isStreaming = false }) => {
  const [processedHtml, setProcessedHtml] = useState('');
  const [followUpQuestions, setFollowUpQuestions] = useState([]);
  const contentRef = useRef(null); // Direct DOM manipulation for streaming

  const navigate = useNavigate();

  console.log("Citations in AnswerBox:", citations);
  console.log("🔄 AnswerBox: Rendered with isStreaming:", isStreaming, "HTML length:", html?.length || 0);

  // Function to extract follow-up questions from HTML response and remove them from HTML
  const extractAndRemoveFollowUpQuestions = (htmlContent) => {
    if (!htmlContent) return { cleanedHtml: htmlContent, questions: [] };

    // Work with the original HTML string but be more specific about what we remove
    let cleanedHtml = htmlContent;
    let questions = [];

    // Look for follow-up questions section - match various formats including capitalized
    const followUpRegex = /<h3[^>]*>\s*[Ff]ollow[-\s]*up\s+questions?\s*:?\s*<\/h3>\s*<ol[^>]*>(.*?)<\/ol>/gis;
    const match = followUpRegex.exec(htmlContent);

    if (match) {
      console.log("Found follow-up questions section:", match[0]);

      // Extract questions from the ol content
      const olContent = match[1];
      const liRegex = /<li[^>]*>(.*?)<\/li>/gis;
      let liMatch;

      while ((liMatch = liRegex.exec(olContent)) !== null) {
        // Strip HTML tags from the li content
        const questionText = liMatch[1].replace(/<[^>]*>/g, '').trim();
        if (questionText) {
          questions.push(questionText);
        }
      }

      console.log("Extracted questions:", questions);

      // Remove only the follow-up questions section from HTML
      cleanedHtml = htmlContent.replace(match[0], '');
    } else {
      console.log("No follow-up questions section found in HTML");
    }

    return {
      cleanedHtml: cleanedHtml.trim(),
      questions: questions
    };
  };

  // Immediate update for streaming content - prevent blinking
  useEffect(() => {
    if (isStreaming && html && contentRef.current) {
      console.log("🔄 AnswerBox: STREAMING - Direct DOM update to prevent blinking");
      
      // Process think blocks during streaming for real-time styling
      let processedStreamingHtml = html;
      
      // Transform think tags to styled divs in real-time
      processedStreamingHtml = processedStreamingHtml.replace(
        /<think>/gi, 
        '<div class="think-block" data-think="true">'
      );
      processedStreamingHtml = processedStreamingHtml.replace(
        /<\/think>/gi, 
        '</div>'
      );
      
      // Direct DOM manipulation prevents React re-rendering flash
      if (contentRef.current.innerHTML !== processedStreamingHtml) {
        contentRef.current.innerHTML = processedStreamingHtml;
      }
      return;
    }

    // Full processing for non-streaming (final) content
    if (html && !isStreaming) {
      console.log("🔄 AnswerBox: NON-STREAMING - Processing HTML");
      
      const processUrls = async (htmlContent) => {
        console.log("=== PROCESSING FINAL HTML ===");

        // First, extract and remove follow-up questions
        const { cleanedHtml, questions } = extractAndRemoveFollowUpQuestions(htmlContent);
        setFollowUpQuestions(questions);
        console.log("Extracted follow-up questions:", questions.length);

        // Process think blocks for better styling
        let updatedHtml = cleanedHtml;
        
        // Enhance think blocks with data attributes for better CSS targeting
        updatedHtml = updatedHtml.replace(
          /<think>/gi, 
          '<div class="think-block" data-think="true">'
        );
        updatedHtml = updatedHtml.replace(
          /<\/think>/gi, 
          '</div>'
        );
        
        console.log("Enhanced think blocks in HTML");

        // Handle blob URLs - these might still need SAS token generation
        const blobUrlRegex = /href="([^"]*blob\.core\.windows\.net[^"]*)"/g;
        const blobMatches = [...updatedHtml.matchAll(blobUrlRegex)];

        if (blobMatches.length > 0) {
          console.log("Processing blob URLs for SAS tokens:", blobMatches.length);
          for (const blobMatch of blobMatches) {
            try {
              const originalUrl = blobMatch[1];
              const sasUrl = await getSasUrl({
                url: originalUrl,
                directory: "",
              });
              const specificBlobRegex = new RegExp(
                `href="${originalUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}"`,
                'g'
              );
              updatedHtml = updatedHtml.replace(
                specificBlobRegex,
                `href="${sasUrl.data.convertedUrl}"`
              );
            } catch (error) {
              console.error('Failed to get SAS URL for:', blobMatch[1], error);
            }
          }
        }

        console.log("=== FINAL PROCESSED HTML ===");
        return updatedHtml;
      };

      processUrls(html).then((processed) => {
        setProcessedHtml(processed);
      }).catch((error) => {
        console.error("Error processing HTML:", error);
        setProcessedHtml(html); // Fallback to raw HTML
      });
    }
  }, [html, isStreaming, getSasUrl]);

  // Handle click events for navigation with citation state
  const handleClick = (event) => {
    const target = event.target.closest('[data-navigate]');
    if (target) {
      event.preventDefault();
      const navigationPath = target.getAttribute('data-navigate');
      const citationType = target.getAttribute('data-citation-type');

      if (navigationPath) {
        // Find the complete citation object based on the citation ID or step ID
        let citationData = null;

        if (citationType === 'ingested') {
          const citationId = target.getAttribute('data-citation-id');
          citationData = citations.find(citation => citation.id === citationId);
          
          // If citation not found in array, extract from HTML attributes
          if (!citationData) {
            citationData = {
              id: citationId,
              title: target.textContent.trim(),
              type: citationType,
              meta: {
                'data-x1': target.getAttribute('data-x1'),
                'data-y1': target.getAttribute('data-y1'),
                'data-x2': target.getAttribute('data-x2'),
                'data-y2': target.getAttribute('data-y2'),
                'data-width': target.getAttribute('data-width'),
                'data-height': target.getAttribute('data-height'),
                'data-page-number': target.getAttribute('data-page-number'),
              }
            };
          }
        } else if (citationType === 'authored') {
          // For authored documents, data-step-id contains the step ID
          const stepId = target.getAttribute('data-step-id');
          
          citationData = citations.find(citation => citation.id === stepId);
          
          // Fallback if not found - create citation with step ID
          if (!citationData) {
            citationData = {
              id: stepId,
              stepId: stepId, // Store the step ID for highlighting
              title: target.textContent.trim(),
              type: citationType
            };
          } else {
            // Ensure stepId is set
            citationData.stepId = stepId;
          }
        }

        // Navigate with the complete citation object as state
        navigate(navigationPath, {
          state: {
            citation: citationData,
            allCitations: citations, // Optionally include all citations
            searchQuery: target.textContent || '', // Include the clicked text
            navigationType: citationType
          }
        });

        console.log("Navigating with citation data:", {
          path: navigationPath,
          citation: citationData,
          type: citationType
        });
      }
    }
  };

  useEffect(() => {
    console.log("Processed HTML content in AnswerBox:", processedHtml);
  }, [processedHtml]);

  // Debug: Log when component re-renders
  console.log("🔄 AnswerBox: RENDER - processedHtml length:", processedHtml?.length || 0, "isStreaming:", isStreaming);

  return (
    <div>
      <div
        className={`streaming-container min-h-[200px] max-h-[800px] overflow-auto ${isStreaming ? 'streaming' : ''} bg-[#fafafa] shadow-md rounded-md p-6 max-w-[83rem] mx-auto mt-6 text-gray-900 text-base leading-relaxed`}
        onClick={handleClick}
      >
        {isStreaming ? (
          // During streaming: Use direct DOM manipulation to prevent blinking
          <div
            ref={contentRef}
            className={`streaming-content [&_ol]:list-decimal [&_ol]:ml-6 [&_li]:mb-2 
                        [&_ul]:list-disc [&_ul]:ml-6 
                        [&_a]:text-blue-600 [&_a]:underline 
                        [&_strong]:font-semibold [&_b]:font-bold 
                        [&_p]:mb-3 streaming-cursor`}
            suppressHydrationWarning
          />
        ) : (
          // After streaming: Use normal React rendering for final content
          <div
            className={`streaming-content [&_ol]:list-decimal [&_ol]:ml-6 [&_li]:mb-2 
                        [&_ul]:list-disc [&_ul]:ml-6 
                        [&_a]:text-blue-600 [&_a]:underline 
                        [&_strong]:font-semibold [&_b]:font-bold 
                        [&_p]:mb-3`}
            dangerouslySetInnerHTML={{ __html: processedHtml || '' }}
          />
        )}
        
        {/* Only show follow-up questions when streaming is complete */}
        {!isStreaming && followUpQuestions.length > 0 && (
          <div className="flex flex-wrap gap-7 mt-10">
            {followUpQuestions.map((question, index) => (
              <button
                key={index}
                onClick={() => onFollowUpClick(question)}
                title={question} // Tooltip with full text
                className="bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200 hover:border-blue-300 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 shadow-sm hover:shadow-md max-w-[25rem] truncate"
              >
                {question}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const SearchResultPage = (props) => {
  // Search results state
  const [searchLoading, setSearchLoading] = useState(false);
  
  // Saras/Answer state  
  const [sarasLoading, setSarasLoading] = useState(false);
  const [answerHTML, setAnswerHTML] = useState({});
  const [citations, setCitations] = useState([]);
  
  // UI state
  const [featureFlag, setFeatureFlag] = useState(props.featureFlag);
  const [clickedQuestion, setClickedQuestion] = useState(null);
  const [chunkCounter, setChunkCounter] = useState(0);
  
  const location = useLocation();
  const STORAGE_KEY = 'searchAnswerData';

  props.addPath("/searchResult");

  // Handle search API independently
  const handleSearchAPI = async (query, searchId) => {
    console.log("🔍 Starting search API for:", query);
    setSearchLoading(true);
    props.setSearchLoading(true); // Update Redux state
    
    try {
      const browserFingerprint = (await getCurrentBrowserFingerPrint()).toString();
      
      const queryToExecute = {
        q: query,
        rows: 10,
        start: 0,
        filter: [],
        searchId: searchId,
        browserFingerprint: browserFingerprint
      };
      
      if (searchId.split("_")[1] === "incorrect") {
        queryToExecute.isIncorrectQuery = true;
      }
      
      const searchRes = await searchApi(queryToExecute);
      console.log("🔍 Search API completed:", searchRes);
      
      if (searchRes?.data) {
        const data = searchRes.data;
        
        // Update Redux state with search results
        props.saveSearchResult(JSON.stringify(data.response.docs));
        
        if (data.response.authDocs?.length > 0) {
          props.saveSearchResultAuthDocs(JSON.stringify(data.response.authDocs));
        } else {
          props.saveSearchResultAuthDocs("");
        }
        
        if (data.equipment !== undefined) {
          props.setEquipment(data.equipment);
        }
        
        if (data.type !== undefined) {
          props.setTypes(data.type);
        }
        
        if (data.spellcheck !== undefined) {
          props.saveSpellcorrection(data.spellcheck);
        }
        
        props.setTotalDoc(data.response.numFound);
        props.setActivePage(1);
      }
      
    } catch (error) {
      console.error("🔍 Search API error:", error);
      props.setToaster(true);
      
      if (error.response?.data === "Access denied" || error.response?.status === 403) {
        KeycloakUserService.doLogout();
      }
    } finally {
      setSearchLoading(false);
      props.setSearchLoading(false); // Update Redux state
    }
  };

  // Handle Saras API independently with streaming
  const handleSarasAPI = async (query) => {
    console.log("🤖 Starting Saras streaming API for:", query);
    setSarasLoading(true);
    setAnswerHTML({});
    setCitations([]);
    setChunkCounter(0);
    
    try {
      await getSarasAnswerStream(
        query,
        // onChunk - real-time streaming updates
        (chunkData) => {
          console.log("🤖 Saras chunk:", chunkData.content);
          
          flushSync(() => {
            setAnswerHTML({
              answer: chunkData.accumulated,
              citations: [],
              isStreaming: true
            });
            setChunkCounter(prev => prev + 1);
          });
        },
        // onComplete - streaming finished
        (finalData) => {
          console.log("🤖 Saras streaming complete:", finalData);
          
          const completeData = {
            answer: finalData.answer,
            citations: finalData.citations || [],
            isStreaming: false
          };
          
          setAnswerHTML(completeData);
          setCitations(finalData.citations || []);
          setSarasLoading(false);
          
          // Store for persistence
          answerStorage.set(STORAGE_KEY, {
            ...completeData,
            timestamp: new Date().toISOString(),
            searchQuery: query
          });
        },
        // onError - streaming failed
        (error) => {
          console.error("🤖 Saras streaming error:", error);
          setSarasLoading(false);
          setAnswerHTML({});
          setCitations([]);
          setChunkCounter(0);
          answerStorage.remove(STORAGE_KEY);
        }
      );
      
    } catch (error) {
      console.error("🤖 Saras API setup error:", error);
      setSarasLoading(false);
      setAnswerHTML({});
      setCitations([]);
      setChunkCounter(0);
    }
  };

  // Handle when search is triggered from ResultSearchBox
  const handleSearchTriggered = (query, searchId) => {
    console.log("🚀 Search triggered for:", query, "with ID:", searchId);
    
    // Start both APIs independently and simultaneously
    handleSearchAPI(query, searchId);
    handleSarasAPI(query);
  };

  // Handle clearing previous results
  const handleClearPreviousResults = () => {
    console.log("🗑️ Clearing previous results");
    setAnswerHTML({});
    setCitations([]);
    setChunkCounter(0);
    setSarasLoading(false);
    setSearchLoading(false);
    props.setSearchLoading(false);
    props.saveSpellcorrection(""); // Clear spell check data
    answerStorage.remove(STORAGE_KEY);
  };



  // Simple initialization - load persisted data if available
  useEffect(() => {
    console.log("🔄 SearchResultPage: Initializing");
    
    // Check if we're navigating from the Search component (initial search)
    if (location.state?.triggerSearch && location.state?.searchQuery) {
      console.log("🔄 SearchResultPage: Triggered from Search component");
      const { searchQuery, searchId } = location.state;
      
      // Trigger both API calls
      handleSearchAPI(searchQuery, searchId);
      handleSarasAPI(searchQuery);
      
      // Clear the navigation state to prevent re-triggering
      window.history.replaceState({}, document.title);
      return;
    }
    
    // Load any persisted answer data
    const persistedData = answerStorage.get(STORAGE_KEY);
    if (persistedData && persistedData.answer && !answerHTML.answer) {
      console.log("📦 Loading persisted answer data");
      setAnswerHTML(persistedData);
      if (persistedData.citations) {
        setCitations(persistedData.citations);
      }
    }
  }, []); // Run once on mount



  // Simple cleanup and persistence
  useEffect(() => {
    props.storeDocDetail({});
  }, []);







  const handleSarasError = () => {
    console.log("🔄 SearchResultPage: handleSarasError called - clearing answer data");
    setSarasLoading(false);
    setAnswerHTML({}); // Clear the answer completely
    setCitations([]);
    answerStorage.remove(STORAGE_KEY);
  };

  // Function to handle follow-up question clicks
  const handleFollowUpClick = (question) => {
    console.log("💭 Follow-up question clicked:", question);
    
    // Update Redux state
    props.saveSearchWord(question);
    
    // Start Saras API for follow-up question (no search API needed)
    handleSarasAPI(question);
  };



  return (
    <div>
      <Navbar />
      <div className="resultboxinresult">
        <ResultSearchBox
          onSearchTriggered={handleSearchTriggered}
          onClearPreviousResults={handleClearPreviousResults}
          followupQuestion={clickedQuestion}
        />
      </div>

      <>
        <div className="flex bg-[#FAFAFA] flex-col-reverse md:flex-row">
          <div>
            <SearchResultOptions />

            {/* Debug: Show streaming status */}
            {answerHTML.isStreaming && (
              <div className="bg-blue-100 border border-blue-300 rounded p-2 text-blue-800 text-sm max-w-[83rem] mx-auto mb-2">
                🤖 Streaming... Chunks received: {chunkCounter} | Content length: {answerHTML.answer?.length || 0} chars
              </div>
            )}



            {/* Saras Answer Section - Independent of search */}
            {sarasLoading && !answerHTML.answer ? (
              <AnswerSkeleton />
            ) : answerHTML.answer ? (
              <AnswerBox
                key={`${answerHTML.isStreaming ? 'streaming' : 'final'}-${chunkCounter}`}
                html={answerHTML.answer}
                getSasUrl={getSasUrl}
                citations={answerHTML.citations || citations}
                onFollowUpClick={handleFollowUpClick}
                isStreaming={answerHTML.isStreaming}
              />
            ) : null}

            {/* Search Results Section - Independent of Saras */}
            <SearchResultBox searchLoading={searchLoading} />
          </div>
        </div>
      </>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    searchResult: state.searchResult,
    searchedWord: state.searchedWord,
    featureFlag: state.featureFlag,
    docDetail: state.docDetail,
  };
};

export default connect(mapStateToProps, {
  addPath,
  storeDocDetail,
  saveSearchWord,
  setSearchId,
  saveSearchResult,
  saveSearchResultAuthDocs,
  setEquipment,
  setTypes,
  setTotalDoc,
  addfilter,
  setActivePage,
  saveSpellcorrection,
  setToaster,
  setSearchLoading
})(SearchResultPage);